import { Typography } from '@mui/material'
import Image from 'next/image'
import { FC } from 'react'
import { IconContainer, Pill } from './styled'

const ExamplePill: FC<IExamplePill> = ({
  example,
  setCurrentMedia,
  setVideoIndex,
  index,
  projectShowcaseVideo,
  videoIndex,
  projectShowcaseImage,
}) => {
  const handleVideo = () => {
    setCurrentMedia(example.video || projectShowcaseVideo || projectShowcaseImage)
    setVideoIndex(index)
  }
  return (
    <Pill onClick={() => handleVideo()} example={example} videoIndex={videoIndex} index={index}>
      {example?.icon?.fullSize && (
        <IconContainer>
          <Image
            src={example?.icon?.fullSize}
            alt={example?.iconAltText}
            layout="fill"
            objectFit="contain"
            objectPosition="center"
          />
        </IconContainer>
      )}

      <Typography variant="button2" sx={{ whiteSpace: 'nowrap' }}>
        {example.name}
      </Typography>
    </Pill>
  )
}

export default ExamplePill
